export const PATERNITY_STUDY_TYPES_ACTIONS = {
    GET_ALL: 'GET_PATERNITY_STUDY_TYPES_ALL',
    GET_ACTIVE: 'GET_PATERNITY_STUDY_TYPES_ACTIVE',
    FIND: 'FIND_PATERNITY_STUDY_TYPES',
    CLEAN: 'CLEAN_PATERNITY_STUDY_TYPES',
    CHANGE_STATUS: 'CHANGE_STATUS_PATERNITY_STUDY_TYPES',
    SUCCESS: 'SUCCESS_PATERNITY_STUDY_TYPES',
    ERROR: 'ERROR_PATERNITY_STUDY_TYPES',

    GET_METHODOLOGIES: 'GET_METHODOLOGIES_PATERNITY_STUDY_TYPES',
    GET_RESULTS: 'GET_RESULTS_PATERNITY_STUDY_TYPES',
}